import {css} from "../../admin/script/libs/lit.dist.js";

// language=CSS
export default css`
    
    :host {
        --button-width: 2.2rem;
        --icon-set: 'bootstrap-icons';
        --icon-size: 1rem;
        --show-icon: '\\F340';
        --hide-icon: '\\F341';
        
        position: relative;
        display: block;
    }

    .show-button,
    .hide-button {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: var(--button-width);
        border: 0 none;
        background: none;
        text-align: center;
        opacity: 0.6;
        font-size: var(--icon-size);
        
        &:after {
            display: inline-block;
            font-family: var(--icon-set) !important;
            font-style: normal;
            font-weight: normal !important;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            vertical-align: -0.125em;
        }
        
        &.show-button:after {
            content: var(--show-icon);
        }
        
        &.hide-button:after {
            content: var(--hide-icon);
        }
    }

    slot::slotted(input) {
        padding-right: var(--button-width) !important;
    }
`;
